// @ts-nocheck
/**
 * Purabelle Bundle Widget
 * Fil: assets/purabelle-bundle.js
 */

(function () {
  'use strict';

  // ─── Konfiguration ────────────────────────────────────────────────────────
  // MARKEDS-SIKKER STIGE — se samme ændring i assets/purabelle-bundle-core.js.
  // Stigen er andele af fuld pris, ikke faste DKK-beløb, så prisen følger
  // markedets valuta. De faste beløb betød at svenske kunder fik vist danske
  // priser på PDP-modulet (3 x 100ml: 699 "kr." i stedet for 1054 SEK).
  const CONFIG = {
    bundleRates: {
      // Andel af fuld pris = 1 − rabatprocenten i Shopify-rabatterne "Mængderabet".
      // Shopify gemmer procenten med 2 decimaler, så tallene skal være præcis de samme.
      '100ml': {
        2: 0.8344,
        3: 0.7793,
        4: 0.6681,
        5: 0.6254,
        6: 0.6254,
      },
      // Ny basis-stige 2026-09-16 (199 kr/stk): 338,98 / 429 / 549 / 668,95 / 789 kr.
      '30ml': {
        2: 0.8517,
        3: 0.7186,
        4: 0.6897,
        5: 0.6723,
        6: 0.6608,
      },
      // 3 ml koster 39 kr: 69 / 99 / 129 / 159 / 189 kr.
      '3ml': {
        2: 0.8847,
        3: 0.8462,
        4: 0.8270,
        5: 0.8155,
        6: 0.8078,
      },
    },
    collections: {
      herre: 'herre',
      damer: 'damer',
    },
    maxVisible: 20,
  };

  // ─── State ────────────────────────────────────────────────────────────────
  let state = {
    mode: 'single',
    selectedSize: null,
    selectedVariantId: null,
    selectedVariantPrice: 0,
    selectedVariantState: 'available',
    bundleQty: 2,
    selectedProducts: [],
    allProducts: [],
    herreHandles: new Set(),
    damerHandles: new Set(),
    allInventoryData: [],
    filter: 'all',
    search: '',
    currentProductId: null,
    labels: {},
  };

  let els = {};

  function getInventoryDataForProduct(productId) {
    return state.allInventoryData.find(i => i.productId == productId);
  }

  function getInventoryDataForVariant(productId, variantId) {
    const inventoryDataForProduct = getInventoryDataForProduct(productId);
    return inventoryDataForProduct ? inventoryDataForProduct.variants.find(v => v.variantId == variantId) : {};
  }

  // ─── Pre-order state is computed server-side (snippets/preorder-variant-state.liquid).
  //     The JS only READS it: 'available' | 'soldout' | 'preorder'. ─────────────────────
  function getVariantState(productId, variantId) {
    const inv = getInventoryDataForVariant(productId, variantId);
    return inv && inv.state ? inv.state : null;
  }

  function getVariantShipDate(productId, variantId) {
    const inv = getInventoryDataForVariant(productId, variantId);
    return inv && inv.shipDate ? inv.shipDate : '';
  }

  function isPreorderVariant(productId, variantId) {
    return getVariantState(productId, variantId) === 'preorder';
  }

  // Theme-owned CTA copy (snippets/preorder-labels.liquid). Never from a metafield.
  function L(key) {
    return (state.labels && state.labels[key]) || '';
  }

  function buildPreorderProps(productId, variantId) {
    if (getVariantState(productId, variantId) !== 'preorder') return undefined;
    const shipDate = getVariantShipDate(productId, variantId);
    const props = {};
    if (shipDate) {
      props[L('cartPreorderKey')] = L('cartPreorderShipsValue').replace('{date}', shipDate);
    } else {
      props[L('cartStatusKey')] = L('cartStatusValue');
    }
    return Object.keys(props).length ? props : undefined;
  }

  function collectInventoryData() {
    const ids = Object.keys(CONFIG.collections).map(h => `${h}-products`);
    ids.push('current-product-inventory');
    for (const id of ids) {
      const json = document.getElementById(id);
      if (json) {
        try {
          state.allInventoryData = state.allInventoryData.concat(JSON.parse(json.textContent));
        } catch (e) {
          console.warn(`Purabelle: kunne ikke parse ${id}`, e);
        }
      }
    }
  }

  function loadLabels() {
    const el = document.getElementById('pb-preorder-labels');
    if (el) {
      try {
        state.labels = JSON.parse(el.textContent);
      } catch (e) {
        console.warn('Purabelle: kunne ikke parse pb-preorder-labels', e);
      }
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  function init() {
    const root = document.getElementById('purabelle-bundle-root');
    if (!root) return;

    collectInventoryData();
    loadLabels();

    state.currentProductId = root.dataset.productId;

    const currentTitle = root.dataset.productTitle;
    const currentImage = root.dataset.productImage;
    state.selectedProducts = [{
      productId: parseInt(state.currentProductId, 10),
      variantId: null,
      title: currentTitle,
      image: currentImage,
      price: 0,
      isCurrentProduct: true,
      isPreorder: isPreorderVariant(state.currentProductId, root.dataset.variantId),
    }];

    try {
      const variants = JSON.parse(root.dataset.variants.replace(/&quot;/g, '"'));

      if (variants && variants.length > 0) {
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');

        const activeVariant = urlVariantId
          ? variants.find(v => v.id == urlVariantId) || variants[0]
          : variants[0];

        state.selectedSize = activeVariant.title;
        state.selectedVariantId = activeVariant.id;
        state.selectedVariantPrice = activeVariant.price;
        state.selectedVariantState = getVariantState(state.currentProductId, activeVariant.id)
          || (activeVariant.available ? 'available' : 'soldout');

        state.selectedProducts[0].variantId = activeVariant.id;
        state.selectedProducts[0].price = activeVariant.price;

        document.querySelectorAll('.pb-size-btn').forEach(btn => {
          btn.classList.toggle('active', btn.dataset.variantId == activeVariant.id);
        });
      }
    } catch (e) {
      console.warn('Purabelle: kunne ikke parse varianter', e);
    }

    if (localStorage.getItem("auto-open-cart-drawer") === "true") {
      localStorage.removeItem("auto-open-cart-drawer");
      document.dispatchEvent(new CustomEvent('cart:update'));
    }

    cacheEls();
    bindEvents();
    updatePriceDisplay();
    updateATCButton();
    fetchAllProducts();
  }

  function cacheEls() {
    els = {
      modeSingle: document.querySelector('[data-mode="single"]'),
      modeBundle: document.querySelector('[data-mode="bundle"]'),
      bundlePanel: document.querySelector('.pb-bundle-panel'),
      qtyTabs: document.querySelectorAll('.pb-qty-tab'),
      productList: document.getElementById('pb-product-list'),
      selectedList: document.getElementById('pb-selected-list'),
      selectedItems: document.getElementById('pb-selected-items'),
      searchInput: document.getElementById('pb-search'),
      filterBtns: document.querySelectorAll('.pb-filter-btn'),
      atcBtn: document.getElementById('pb-atc-btn'),
      sizeBtns: document.querySelectorAll('.pb-size-btn'),
      qtyNeeded: document.querySelector('.pb-qty-needed'),
      bundleFromPrice: document.querySelector('.pb-bundle-from-price'),
      scrollHint: document.querySelector('.pb-scroll-hint'),
      bundleContainer: document.querySelector('.pb-mode-option[data-mode="bundle"]'),
    };
  }

  function bindEvents() {
    els.sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        els.sizeBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const variantId = btn.dataset.variantId;
        const nativeVariantInput = document.querySelector('input[name="id"]');
        if (nativeVariantInput) {
          nativeVariantInput.value = variantId;
          nativeVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        window.location.href = `${window.location.pathname}?variant=${variantId}`;

        state.selectedSize = btn.dataset.size;
        state.selectedVariantId = btn.dataset.variantId;
        state.selectedVariantPrice = parseInt(btn.dataset.price, 10);
        state.selectedVariantState = getVariantState(state.currentProductId, btn.dataset.variantId)
          || (btn.dataset.available === 'true' ? 'available' : 'soldout');
        state.selectedProducts = [];
        updateSelectedUI();
        renderProductList();
        updatePriceDisplay();
        updateATCButton();
      });
    });

    els.modeSingle.addEventListener('click', () => setMode('single'));
    els.modeBundle.addEventListener('click', () => setMode('bundle'));

    els.searchInput.addEventListener('input', (e) => {
      state.search = e.target.value.toLowerCase();
      renderProductList();
    });

    els.filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        els.filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        state.filter = btn.dataset.filter;
        renderProductList();
      });
    });

    els.atcBtn.addEventListener('click', handleAddToCart);
  }

  // ─── Mode ─────────────────────────────────────────────────────────────────
  function setMode(mode) {
    state.mode = mode;
    els.modeSingle.classList.toggle('active', mode === 'single');
    els.modeBundle.classList.toggle('active', mode === 'bundle');
    els.bundlePanel.style.display = mode === 'bundle' ? 'block' : 'none';
    updateSelectedUI();
    updateATCButton();
  }

  // ─── i18n ─────────────────────────────────────────────────────────────────
  // Læser strenge fra #pb-i18n, som snippets/purabelle-bundle.liquid renderer
  // server-side fra locale-filerne. Tidligere var de danske literals herinde,
  // og de kunne hverken redigeres i Shopify eller oversættes pr. marked.
  function t(key) {
    const bank = document.getElementById('pb-i18n');
    const el = bank && bank.querySelector('[data-i18n="' + key + '"]');
    return el ? el.textContent.trim() : key;
  }
  function tf(key, vars) {
    let s = t(key);
    if (vars) for (const k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }

  // ─── Priser ───────────────────────────────────────────────────────────────
  // Valuta og talformat følger markedet. Ingen hardcodet "kr." — den var
  // forkert på ethvert ikke-dansk marked.
  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
  }

  function activeLocale() {
    return document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'da';
  }

  // Hele kroner i visningen på kr-markeder (DKK/SEK): kurven kan vise 498,98, siden viser
  // 499. EUR beholder cent, fordi prispunkterne ender på ,95.
  function displayTotal(minor) {
    return /^(DKK|SEK|NOK)$/.test(activeCurrency()) ? Math.round(minor / 100) * 100 : minor;
  }

  function formatPrice(priceInMinorUnits) {
    const amount = (priceInMinorUnits || 0) / 100;
    try {
      // Decimaler kun når beløbet faktisk har dem: "699 kr." på DKK/SEK, men
      // "95,74 €" på EUR, hvor prispunkterne ender på ,95. Fast 0 decimaler
      // ville skjule cents og vise en pris kunden ikke betaler.
      const fraction = Number.isInteger(amount) ? 0 : 2;
      return new Intl.NumberFormat(activeLocale(), {
        style: 'currency',
        currency: activeCurrency(),
        minimumFractionDigits: fraction,
        maximumFractionDigits: fraction,
      }).format(amount);
    } catch (e) {
      return Math.round(amount).toString() + ' ' + activeCurrency();
    }
  }


  // Rabat-stigen fra theme-indstillingerne (#pbb-discounts, renderet af
  // snippets/purabelle-bundle-discounts.liquid). Samme kilde som bygger-siden.
  // Falder tilbage til CONFIG hvis snippet'en mangler.
  let rateTable = null;
  function rates() {
    if (rateTable) return rateTable;
    rateTable = {};
    const node = document.getElementById('pbb-discounts');
    if (node) {
      try {
        JSON.parse(node.textContent).forEach((t) => {
          if (!t || !t.size || !t.qty) return;
          const pct = parseFloat(t.percent);
          if (!isFinite(pct)) return;
          (rateTable[t.size] = rateTable[t.size] || {})[t.qty] = 1 - pct / 100;
        });
      } catch (e) {
        console.warn('Purabelle: kunne ikke parse #pbb-discounts', e);
      }
    }
    if (!Object.keys(rateTable).length) rateTable = CONFIG.bundleRates;
    return rateTable;
  }

  // Samlet bundle-pris for N flasker, beregnet ud fra markedets enhedspris.
  // Ingen afrunding til hele valutaenheder — det brød EUR-prispunkter (,95).
  // Samme normalisering som byggeren: varianttitlen er oversat på nogle
  // produkter ("100 ml"), og et opslag på den rå titel ramte forbi stigen.
  function sizeKey(s) {
    return (s || '').toLowerCase().replace(/\s+/g, '');
  }

  function bundleTotalFor(qty) {
    const all = rates();
    const key = sizeKey(state.selectedSize);
    const byKey = {};
    Object.keys(all).forEach(k => { byKey[sizeKey(k)] = all[k]; });
    const r = byKey[key] || byKey['100ml'] || CONFIG.bundleRates['100ml'];
    const base = state.selectedVariantPrice || 0;
    // 6+ flasker bruger 6-trinnet, som Shopify-rabatten "6 stk" (minimum 6).
    const rate = r[qty] || r[6] || r[5] || r[4];
    if (rate == null) return base * qty;
    // Shopify trækker procentrabatten pr. kurvlinje og runder rabatten NED til helt øre/cent
    // pr. linje (set i rigtige kurve 2026-09-16). Hver valgt flaske er sin egen linje, så
    // totalen er antal × (pris − nedrundet rabat), også på SEK/EUR. Heltal i basispoint.
    const bp = Math.round((1 - rate) * 10000);
    return qty * (base - Math.floor((base * bp) / 10000));
  }

  function getDiscountedPrice(qty) {
    return displayTotal(Math.round(bundleTotalFor(qty) / qty));
  }

  function updatePriceDisplay() {
    const base = state.selectedVariantPrice;
    if (!base) return;

    const lowestPrice = getDiscountedPrice(4);
    if (els.bundleFromPrice) {
      els.bundleFromPrice.textContent = formatPrice(lowestPrice);
    }

    els.qtyTabs.forEach(tab => {
      const qty = parseInt(tab.dataset.qty, 10);
      const discountedPrice = getDiscountedPrice(qty);
      // Rettet: slog tidligere op i CONFIG.bundlePrices[qty] (det ydre objekt er
      // nøglet på størrelse, ikke antal), så 'saved' altid var 0 og "Spar …"
      // aldrig blev vist.
      const saved = base * qty - displayTotal(bundleTotalFor(qty));

      const priceEl = tab.querySelector('.pb-qty-price');
      const saveEl = tab.querySelector('.pb-qty-save');

      if (priceEl) priceEl.textContent = formatPrice(discountedPrice) + ' ' + t('per_unit');
      if (saveEl && saved > 0) saveEl.textContent = tf('save', { amount: formatPrice(saved) });
    });
  }

  // ─── Hent produkter ───────────────────────────────────────────────────────
  async function fetchAllProducts() {
    try {
      await Promise.all([
        fetchCollectionHandles(CONFIG.collections.herre, state.herreHandles),
        fetchCollectionHandles(CONFIG.collections.damer, state.damerHandles),
      ]);

      const res = await fetch('/products.json?limit=250');
      const data = await res.json();
      state.allProducts = data.products || [];
      renderProductList();

    } catch (err) {
      console.error('Purabelle: fejl ved hentning af produkter', err);
      if (els.productList) {
        els.productList.innerHTML = '<p class="pb-error"></p>';
        els.productList.firstChild.textContent = t('load_error');
      }
    }
  }

  async function fetchCollectionHandles(collectionHandle, targetSet) {
    try {
      let page = 1;
      let keepFetching = true;
      while (keepFetching) {
        const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250&page=${page}`);
        const data = await res.json();
        if (data.products && data.products.length > 0) {
          data.products.forEach(p => targetSet.add(p.handle));
          page++;
          if (data.products.length < 250) keepFetching = false;
        } else {
          keepFetching = false;
        }
      }
    } catch (e) {
      console.warn(`Purabelle: kunne ikke hente kollektion "${collectionHandle}"`, e);
    }
  }

  // ─── Render produktliste ──────────────────────────────────────────────────
  function renderProductList() {
    if (!els.productList) return;

    const size = state.selectedSize;
    const search = state.search;
    const filter = state.filter;
    const currentId = parseInt(state.currentProductId, 10);

    let filtered = state.allProducts.filter(product => {
      if (product.id === currentId) return false;

      const hasSize = product.variants.some(v =>
        v.title.toLowerCase() === size.toLowerCase() && v.available
      );
      if (!hasSize) return false;

      if (filter === 'herre' && !state.herreHandles.has(product.handle)) return false;
      if (filter === 'damer' && !state.damerHandles.has(product.handle)) return false;

      if (search && !product.title.toLowerCase().includes(search)) return false;

      return true;
    });

    const selectedIds = new Set(state.selectedProducts.map(p => p.productId));
    filtered.sort((a, b) => {
      const aSelected = selectedIds.has(a.id) ? 0 : 1;
      const bSelected = selectedIds.has(b.id) ? 0 : 1;
      return aSelected - bSelected;
    });

    if (filtered.length === 0) {
      els.productList.innerHTML = '<p class="pb-no-results"></p>';
      els.productList.firstChild.textContent = t('no_results');
      if (els.scrollHint) els.scrollHint.style.display = 'none';
      return;
    }

    if (els.scrollHint) {
      els.scrollHint.style.display = filtered.length > 4 ? 'block' : 'none';
    }

    const html = filtered.map(product => {
      const variant = product.variants.find(v =>
        v.title.toLowerCase() === size.toLowerCase()
      );
      if (!variant) return '';

      const vstate = getVariantState(product.id, variant.id);
      const isPreorder = vstate === 'preorder';
      // Fallback to the Storefront `available` flag when this product has no server
      // state (e.g. it is not in the herre/damer inventory JSON).
      const isAvailable = vstate ? vstate !== 'soldout' : variant.available;

      const isSelected = selectedIds.has(product.id);
      const image = product.images[0]
        ? product.images[0].src.replace('.jpg', '_100x100.jpg').replace('.png', '_100x100.png').replace('.webp', '_100x100.webp')
        : '';

      return `
        <div data-preorder="${isPreorder.toString()}" class="pb-product-item ${isSelected ? 'selected' : ''}"
          data-product-id="${product.id}"
          data-variant-id="${variant.id}"
          data-title="${product.title.replace(/"/g, '&quot;')}"
          data-image="${image}"
          data-price="${variant.price}"
        >
          <div class="pb-product-img">
            ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : '<div class="pb-img-placeholder"></div>'}
          </div>
          <div class="pb-product-info">
            <span class="pb-product-title">${product.title}</span>
            ${getGenderTag(product.handle)}
          </div>
          <button class="pb-add-btn ${isSelected ? 'added' : isPreorder ? 'preorder' : ''}" type="button" data-preorder="${isPreorder.toString()}" data-availability="${isAvailable.toString()}" ${isAvailable ? '' : 'disabled'}>
            ${isSelected ? L('added') : isPreorder ? L('preorder') : isAvailable ? L('add') : L('soldOut')}
          </button>
        </div>
      `;
    }).join('');

    els.productList.innerHTML = html;

    els.productList.querySelectorAll('.pb-product-item').forEach(item => {
      item.addEventListener('click', () => toggleProduct(item));
    });
  }

  function getGenderTag(handle) {
    if (state.herreHandles.has(handle)) {
      return '<span class="pb-gender-tag herre">HERRE</span>';
    }
    if (state.damerHandles.has(handle)) {
      return '<span class="pb-gender-tag damer">DAMER</span>';
    }
    return '<span class="pb-gender-tag unisex">UNISEX</span>';
  }

  // ─── Toggle produkt i bundle ───────────────────────────────────────────────
  function toggleProduct(item) {
    const productId = parseInt(item.dataset.productId, 10);
    const variantId = parseInt(item.dataset.variantId, 10);
    const title = item.dataset.title;
    const image = item.dataset.image;
    const price = parseInt(item.dataset.price, 10);
    const isPreorder = item.dataset.preorder === 'true';

    const existingIndex = state.selectedProducts.findIndex(p => p.productId === productId);

    if (existingIndex > -1) {
      state.selectedProducts.splice(existingIndex, 1);
    } else {
      state.selectedProducts.push({ productId, variantId, title, image, price, isPreorder });
    }

    const count = state.selectedProducts.length;
    state.bundleQty = count >= 5 ? 5 : count >= 2 ? count : 2;

    updateQtyTabsUI();
    updateSelectedUI();
    renderProductList();
    updateATCButton();
  }

  // ─── Opdater qty tabs UI ──────────────────────────────────────────────────
  function updateQtyTabsUI() {
    const count = state.selectedProducts.length;
    els.qtyTabs.forEach(tab => {
      const qty = parseInt(tab.dataset.qty, 10);
      tab.classList.remove('active');
      if (count >= 2) {
        if (count >= 4 && qty === 4) tab.classList.add('active');
        else if (count === 3 && qty === 3) tab.classList.add('active');
        else if (count === 2 && qty === 2) tab.classList.add('active');
      }
    });

    const displayCount = count >= 2 ? count + 1 : 2;
    if (els.qtyNeeded) els.qtyNeeded.textContent = displayCount;
  }

  // ─── Opdater "Din pakke" sektion ──────────────────────────────────────────
  function updateSelectedUI() {
    if (!els.selectedList || !els.selectedItems) return;

    if (state.selectedProducts.length === 0 || state.mode !== 'bundle') {
      els.selectedList.style.display = 'none';
      return;
    }

    els.selectedList.style.display = 'block';
    els.selectedItems.innerHTML = state.selectedProducts.map(p => `
      <div class="pb-selected-item">
        ${p.image ? `<img src="${p.image}" alt="${p.title}">` : ''}
        <span>${p.title} ${p.isPreorder ? ' <i>' + L('preorderTag') + '</i>' : ''}</span>
        <button class="pb-remove-btn" data-product-id="${p.productId}" type="button">×</button>
      </div>
    `).join('');

    els.selectedItems.querySelectorAll('.pb-remove-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = parseInt(btn.dataset.productId, 10);
        state.selectedProducts = state.selectedProducts.filter(p => p.productId !== id);
        updateQtyTabsUI();
        updateSelectedUI();
        renderProductList();
        updateATCButton();
      });
    });
  }

  // ─── Opdater ATC knap ─────────────────────────────────────────────────────
  function updateATCButton() {
    if (!els.atcBtn) return;

    if (state.mode === 'single') {
      els.atcBtn.classList.remove('loading', 'incomplete');
      els.bundleContainer.classList.remove('preorder', 'out-of-stock');
      const vstate = getVariantState(state.currentProductId, state.selectedVariantId) || state.selectedVariantState;
      if (vstate === 'preorder') {
        els.atcBtn.disabled = false;
        els.bundleContainer.classList.add('preorder');
        const shipDate = getVariantShipDate(state.currentProductId, state.selectedVariantId);
        els.atcBtn.innerHTML = shipDate
          ? L('preorderWithDate').replace('{date}', shipDate)
          : L('preorder');
      } else if (vstate === 'soldout') {
        els.atcBtn.disabled = true;
        els.atcBtn.classList.add('incomplete');
        els.bundleContainer.classList.add('out-of-stock');
        els.atcBtn.innerHTML = L('soldOut');
      } else {
        els.atcBtn.disabled = false;
        els.atcBtn.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="1.5"/>
            <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="1.5"/>
            <path d="M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          ${L('addToCart')}
        `;
      }
      return;
    }

    const selected = state.selectedProducts.length;
    const remaining = 2 - selected;

    if (selected < 2) {
      els.atcBtn.disabled = true;
      els.atcBtn.classList.add('incomplete');
      els.atcBtn.classList.remove('loading');
      els.atcBtn.textContent = tf('choose_more', { n: remaining });
    } else {
      els.atcBtn.disabled = false;
      els.atcBtn.classList.remove('incomplete', 'loading');
      // Prisen følger de faktisk valgte flasker. bundleQty var kappet ved 5 og blev ikke
      // opdateret når en flaske blev fjernet, så 6 flasker viste 5-flaskers prisen.
      const discountedTotal = displayTotal(bundleTotalFor(selected));
      els.atcBtn.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="1.5"/>
          <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="1.5"/>
          <path d="M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        ${tf('atc', { price: formatPrice(discountedTotal) })}
      `;
    }
  }

  // ─── Tilføj til kurv ──────────────────────────────────────────────────────
  async function handleAddToCart() {
    if (els.atcBtn.disabled) return;

    els.atcBtn.classList.add('loading');
    els.atcBtn.textContent = t('adding');

    try {
      if (state.mode === 'single') {
        await addToCart([{
          id: state.selectedVariantId,
          quantity: 1,
          properties: buildPreorderProps(state.currentProductId, state.selectedVariantId),
        }]);

      } else {
        const items = state.selectedProducts.map(p => ({
          id: p.variantId,
          quantity: 1,
          properties: buildPreorderProps(p.productId, p.variantId),
        }));
        await addToCart(items);
      }

      localStorage.setItem("auto-open-cart-drawer", "true");
      location.reload();

      const firstProduct = state.selectedProducts[0];
      state.selectedProducts = [firstProduct];
      updateQtyTabsUI();
      updateSelectedUI();
      renderProductList();
      updateATCButton();

    } catch (err) {
      console.error('Purabelle: cart fejl', err);
      alert(t('cart_error'));
    } finally {
      els.atcBtn.classList.remove('loading');
      updateATCButton();
    }
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Cart fejl');
    }

    return res.json();
  }

  // ─── Start ────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();